import { List, ListItem, LoadingShimmer } from '@icarros/ids-react';

import { EDIT_ROUTES } from '../../../utils/adEditRoutes';
import React from 'react';
import { ResumePlateWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { useAdContext } from '../../../store/contexts/ad';

export function VehicleChassis(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  return (
    <ResumePlateWrapper>
      <List>
        <LoadingShimmer show={!currentAd} height="60px">
          <ListItem
            hasLine={false}
            label="8 últimos dígitos do chassi"
            subLabel="ocultada no anúncio"
            descript={currentAd.chassiVerificado?.mensagem ?? ''}
            variant={currentAd.chassiVerificado?.status ? 'simple' : 'action'}
            actionOnClick={() => {
              pushToEditForm(EDIT_ROUTES.chassi.name);
            }}
          />
        </LoadingShimmer>
      </List>
    </ResumePlateWrapper>
  );
}
